export enum FgStockStatusEnum {
    StockIn = 'StockIn',
    StockOut = 'StockOut',
    Cancelled = 'Cancelled',
}